<div class="w-100 h-100 d-flex flex-column justify-content-between p-3 p-md-0 py-md-3">

  <div class="d-flex justify-content-between align-items-center">
    <h3 class="m-0">{{'ADMIN.SCHOOLBUS.LIST_TITLE' | translate}}</h3>
    <button mat-icon-button
      class="d-block d-md-none"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="flex-grow-1 children-list">
    <mat-nav-list>
      <mat-list-item *ngFor="let bus of buses; trackBy:trackByFn"
        class="border-bottom p-0"
        [ngClass]="{
          'selected': storeService.store.dashboardSelectedBus ? storeService.store.dashboardSelectedBus.id === bus.id : false,
          'bus-idle': !bus.isOnActiveRide
        }"
        (click)="onBusClick(bus)"
        (mouseenter)="busMouseEnter.emit(bus)"
        (mouseleave)="busMouseLeave.emit(bus)">
        <div mat-line
          class="d-flex align-items-center justify-content-between">
          <h4 class="m-0 text-truncate bus-title"
            matTooltip="{{bus.dashboardLabel || bus.plate}}">{{bus.dashboardLabel || bus.plate}}</h4>
          <div class="d-flex align-items-center flex-shrink-0">
            <span class="bus-status-chip"
              [ngClass]="bus.isOnActiveRide ? 'bus-status-chip--active' : 'bus-status-chip--idle'">
              <mat-icon class="bus-status-chip__icon">
                {{ bus.isOnActiveRide ? 'directions_bus' : 'pause_circle_filled' }}
              </mat-icon>
              {{ (bus.isOnActiveRide ? 'ADMIN.SCHOOLBUS.IN_RIDE' : 'ADMIN.SCHOOLBUS.IDLE') | translate }}
            </span>
            <mat-icon class="unfollow"
              [ngClass]="{'follow': isFollowingMe(bus) }">
              near_me
            </mat-icon>
          </div>
        </div>
        <div matLine
          *ngIf="bus.isOnActiveRide && bus.activeRoutePlan?.name">
          <span class="mat-caption">
            {{ bus.activeRoutePlan.name }}
          </span>
        </div>
        <div matLine>
          <span class="mat-caption">
            <span>{{'COMMON.LABEL.NUMBER_OF_CHILDREN_ON_BOARD' | translate}}</span>:
            <span class="font-weight-bold">
              {{bus.numOfChildrenOnBoard}}
            </span>
          </span>
        </div>
        <div mat-line>
          <span class="mat-caption">
            {{'COMMON.LABEL.DETECTED_AT' | translate}}:
            {{bus.location.createdAt | date:'dd-MM-yyyy HH:mm:ss'}}
          </span>
        </div>
      </mat-list-item>
    </mat-nav-list>
  </div>

  <div class="d-flex">
    <div class="col-12 px-1">
      <button mat-raised-button
        [color]="getFollowAllBusesColor"
        class="w-100"
        (click)="onFollowAllBuses()">
        {{'COMMON.LABEL.FOLLOW_ALL' | translate}}
      </button>
    </div>

    <div class="col-12 px-1">
      <button mat-raised-button
        [color]="getStopFollowAllBusesColor"
        class="w-100"
        (click)="onStopFollowAllBuses()">
        {{'COMMON.LABEL.UNFOLLOW' | translate}}
      </button>
    </div>
  </div>

</div>
